// root state object.
// each Vuex instance is just a single state tree.
const state = {
    selectedVideosList: [],
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
    /**
     * Add video to selected list
     *
     * @function   addVideoToSelectedList
     */
    addVideoToSelectedList (state, video) {
        if (state.selectedVideosList.filter(sv => sv.id === video.id).length > 0) {
            state.selectedVideosList = state.selectedVideosList.filter(function (v) {
                return v.id !== video.id;
            });
        } else {
            state.selectedVideosList.push(video);
        }
    },
    /**
     * Change the content of the selected videos list
     *
     * @function   updateVideoSelectedList
     */
    updateVideoSelectedList (state, videosList) {
        state.selectedVideosList = videosList;
    },
    /**
     * Delete the content of selectedVideosList
     *
     * @function   clearVideoSelectedList
     */
    clearVideoSelectedList (state) {
        state.selectedVideosList = [];
    }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
    addVideoToSelectedList: ({ state, commit }, video) => commit('addVideoToSelectedList', video),
    updateVideoSelectedList: ({ state, commit }, videosList) => commit('updateVideoSelectedList', videosList),
    clearVideoSelectedList: ({ commit }) => commit('clearVideoSelectedList'),
};

// getters are functions
const getters = {
    /**
     * Get selectedVideosList
     */
    getSelectedVideosList:  state => state.selectedVideosList
};

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./demo/store/modules/selected-viedos.js